/**
 * Emap 导入默认参数配置
 */
const noop = _ => _;

export default {
  contextPath: '',
  // 请求上下文
  downloadTplName: '导入模板',
  // 重命名下载导入模板的名称
  templateUrl: '',
  // 获取模板信息的接口
  uploadTempUrl: '',
  // 上传临时文件的接口
  uploadUrl: '',
  // 上传正式文件接口,
  rownumUrl: '',
  // 获取表格行数的接口
  importUrl: '',
  // 执行导入的接口
  app: '',
  // 应用名
  module: '',
  // 模型名称
  page: '',
  // 页面名称
  action: '',
  // 动作名称
  storeId: 'imexport',
  // 存储id
  params: {},
  // 请求参数
  beforeTmpFile: noop,
  afterTmpFile: noop,
  beforeUpload: noop,
  afterUpload: noop,
  beforeRownum: noop,
  afterRownum: noop,
  beforeImport: noop,
  afterImport: noop,
  isSingle: '0',
  // 是否为单文件上传
  fileName: 'files[]',
  getTemplateDownloadUrl: null,
  // 根据模板文件 id 返回模板下载地址
  getResultDownloadUrl: null // 根据模板文件 id 返回结果下载地址
  // storeId: 'file', // 文件名称
  // tplUrl: '', // 模板下载地址

};